import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import Lineup from './Lineup';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
export default class CommunityLineupsModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.match = this.attrs.match;
  }
  className() {
    return 'CommunityLineupsModal Modal--large';
  }
  title() {
    return "Alineaciones de la Comunidad: ".concat(this.match.getName());
  }
  content() {
    const lineups = this.match.userMatchLineups() || [];

    // Group by 11 players (sorted name comparison)
    const groups = {};
    lineups.forEach(l => {
      if (!l.user() || !l.playersRaw()) return;
      const players = l.playersRaw().split(',').map(p => {
        const parts = p.split(':');
        if (parts.length >= 3 && !isNaN(Number(parts[1]))) {
          return parts.slice(2).join(':').trim().toLowerCase();
        }
        return parts.length >= 2 ? parts.slice(1).join(':').trim().toLowerCase() : p.trim().toLowerCase();
      }).filter(name => name && name !== '?');
      if (players.length !== 11) return;
      const key = players.sort().join(',');
      if (!groups[key]) {
        groups[key] = {
          users: [],
          lineup: l
        };
      }
      groups[key].users.push(l.user());
    });
    const sortedGroups = Object.values(groups).sort((a, b) => b.users.length - a.users.length);
    return m("div", {
      className: "Modal-body",
      style: "max-height: 80vh; overflow-y: auto;"
    }, sortedGroups.length > 0 ? m("div", {
      className: "CommunityLineups-Grid",
      style: "display: flex; flex-direction: column; gap: 25px; width: 100%; padding: 10px 0;"
    }, sortedGroups.map((group, idx) => m("div", {
      key: idx,
      className: "CommunityLineup-Card",
      style: "border-radius: 16px; padding: 20px; background: #fff; border: 1px solid rgba(0,0,0,0.06); box-shadow: 0 2px 8px rgba(0,0,0,0.02); display: flex; flex-direction: column; gap: 15px; width: 100%; box-sizing: border-box;"
    }, m("div", {
      className: "CommunityLineup-Users",
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("span", {
      style: "font-weight: 700; font-size: 1.05em; display: flex; align-items: center; gap: 6px;"
    }, m("span", {
      style: "background: #ef4444; color: #fff; border-radius: 12px; padding: 2px 8px; font-size: 0.85em; font-weight: 800;"
    }, "#", idx + 1), group.users.length, " ", group.users.length === 1 ? 'forero ha' : 'foreros han', " elegido este once:"), m("div", {
      className: "CommunityLineup-Avatars",
      style: "display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-top: 5px;"
    }, group.users.map(user => {
      const userUrl = app.route('user', {
        username: user.slug()
      });
      return m("a", {
        href: userUrl,
        className: "CommunityLineup-UserChip",
        style: "display: inline-flex; align-items: center; gap: 6px; border-radius: 20px; padding: 4px 10px 4px 6px; font-size: 0.85em; text-decoration: none; font-weight: 600; background: #f8f9fa; border: 1px solid #e9ecef; box-shadow: 0 1px 3px rgba(0,0,0,0.02); transition: all 0.15s;"
      }, avatar(user, {
        className: 'Player-Avatar-Tiny',
        style: 'width: 20px; height: 20px; font-size: 9px;'
      }), m("span", null, username(user)));
    }))), m("div", {
      style: "display: flex; justify-content: center; width: 100%;"
    }, m("div", {
      className: "UserMatchLineup-pitch-preview",
      style: "width: 100%; max-width: 480px; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.08);"
    }, m(Lineup, {
      formation: group.lineup.formation(),
      kit: group.lineup.kit(),
      players: group.lineup.playersRaw()
    })))))) : m("div", {
      style: "padding: 30px; text-align: center; color: #999; font-style: italic;"
    }, "No hay alineaciones registradas para este partido."));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/CommunityLineupsModal', CommunityLineupsModal);